export const statusMap: any = {
    1: 'PENDING',
    2: 'REVISI',
    3: 'REJECT',
    4: 'APPROVED'
  };